<template>
  <div>企业管理</div>
</template>

<script>
  export default {
    name: "BusinessManagement"
  }
</script>

<style scoped>

</style>
